import { Autocomplete, Grid, Typography } from "@mui/material";
import PrimaryButton from "components/PrimaryButton";
import SecondaryButton from "components/SecondaryButton";
import StyledTextField from "components/StyledTextField";
import { TechnicianType } from "operations/schema/schema";
import { FC, useCallback, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useAppSelector } from "store";

export interface TechnicianSelectProps {
  onCancel: () => void;
  onSendTechnicianEmail: (engineer: TechnicianType) => void;
}

export const TechnicianSelect: FC<TechnicianSelectProps> = (props) => {
  const intl = useIntl();
  const { onCancel, onSendTechnicianEmail } = props;
  const [selectedTechnician, setSelectedTechnician] = useState<TechnicianType | null>(null);
  const { technicians } = useAppSelector((s) => s.cache);

  const onCancelClicked = useCallback(() => {
    setSelectedTechnician(null);
    onCancel();
  }, [onCancel]);

  const onSendEmailClicked = useCallback(() => {
    if (!selectedTechnician) return;
    onSendTechnicianEmail(selectedTechnician);
  }, [onSendTechnicianEmail, selectedTechnician]);

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Typography>
          <FormattedMessage id="remoteAccess.chooseTechnician" />
        </Typography>
      </Grid>

      <Grid item>
        <Autocomplete
          options={technicians}
          getOptionLabel={(option) => `${option.name}`}
          renderInput={(params) => (
            <StyledTextField
              {...params}
              label={intl.formatMessage({ id: "remoteAccess.technician" })}
            />
          )}
          value={selectedTechnician}
          data-testid="RemoteAccess-TechnicianSelect"
          onChange={(_, value) => {
            setSelectedTechnician(value);
          }}
          isOptionEqualToValue={(option, value) => option.id === value.id}
        />
      </Grid>
      <Grid item>
        <PrimaryButton onClick={onSendEmailClicked} disabled={!selectedTechnician}>
          <FormattedMessage id="remoteAccess.sendByEmail" />
        </PrimaryButton>
      </Grid>
      <Grid item>
        <SecondaryButton onClick={onCancelClicked}>
          <FormattedMessage id="general.cancel" />
        </SecondaryButton>
      </Grid>
    </Grid>
  );
};
